var KeyboardUtil = {
  keyCodes: {
    esc: 27,
    leftArrow: 37,
    rightArrow: 39
  }
};

module.exports = KeyboardUtil;
